/**
 * Publiczna witryna postępowań (postepowania.elgw5.com) — reguły hosta.
 *
 * Subdomena serwuje TĘ SAMĄ aplikację, ale pokazuje wyłącznie witrynę: listę
 * postępowań i ich szczegóły. Zalogowany też jej nie opuszcza samoczynnie —
 * dostaje przycisk przejścia do portalu, bo to jego decyzja, nie nasza.
 *
 * Klasyczny portal żyje na domenie głównej i tam prowadzą wszystkie linki „do
 * systemu": sesja i tak jest per origin, a rozdzielenie tych dwóch światów po
 * hoście sprawia, że witryna nigdy nie renderuje zalogowanej powłoki.
 */

export const PUBLIC_HOST_PREFIX = "postepowania.";

/** Ścieżki, które wolno otworzyć na publicznej subdomenie. */
export const PUBLIC_PATH_PREFIX = "/postepowania";

export function isPublicHost(hostname = window.location.hostname): boolean {
  return hostname.startsWith(PUBLIC_HOST_PREFIX);
}

/**
 * Adres tej samej ścieżki w klasycznym portalu.
 *
 * Na witrynie musi być BEZWZGLĘDNY (inny host), w portalu wystarczy sama ścieżka.
 * Port zachowujemy, żeby działało też lokalnie: postepowania.localhost:5173 →
 * localhost:5173.
 */
export function portalUrl(path: string, location = window.location): string {
  if (!isPublicHost(location.hostname)) return path;
  const host = location.hostname.slice(PUBLIC_HOST_PREFIX.length);
  const port = location.port ? `:${location.port}` : "";
  return `${location.protocol}//${host}${port}${path}`;
}
